<template>
  <div v-if="view" class="widthFull mt-md-5 mb-md-0" id="active">
    <loading v-if="loadingState" />
    <div class="container-fluid blackGradient pt-md-4">
      <div class="row back-2 mb-3">
        <div class="col-md-8">
          <h1
            class="uppercase pt-3 pb-2 pt-md-2 pb-md-2 pl-3 mb-3 mt-md-3"
            :class="{ h5: vw < 800 }"
          >
            Promozioni attive
          </h1>
        </div>
      </div>
      <div v-if="view" class="row justify-content-center">
        <router-link
          v-for="(contest, index) in contests"
          :index="index"
          :key="index"
          class="
            col-lg-6 col-md-8 col-10
            mb-3
            pl-lg-0
            pr-lg-0
            mr-lg-2
            ml-lg-2
            box
          "
          :class="{ 'col-lg-7': vw < 1500 && vw > 1000 }"
          :to="{
            name: 'Contest',
            params: { id: contest.id, piva: piva, cod: cod_client },
          }"
        >
          <div
            v-on:mouseover="mouseOver(index)"
            v-on:click="goToContest(index)"
            class="div first"
          >
            <transition name="slide-fade">
              <h4
                v-if="active == 'ACTIVE' + index"
                class="testo-home center Bold"
                :style="
                  'background:rgb(255,255,255);color:' +
                  contest.config.COLORE_SCURO +
                  ';background:linear-gradient(328deg, rgba(255,255,255,1) 0%, ' +
                  contest.config.COLORE_CHIARO +
                  ' 15%, ' +
                  contest.config.COLORE_MEDIO_CHIARO +
                  ' 62%, ' +
                  contest.config.COLORE_MEDIO_SCURO +
                  ' 100%, ' +
                  contest.config.COLORE_SCURO +
                  ' 100%);zindex:1000'
                "
              >
                {{ contest.config.TESTO_HOME }}
              </h4>
            </transition>
            <img class="img-fluid img" :src="contest.config.IMMAGINE_HOME" />
          </div>
        </router-link>
      </div>
      <div
        v-else
        class="row justify-content-center align-self-center pb-5 pt-5 h1 Medium"
      >
        <div class="col-10">
          <h5 class="displ uppercase">
            Non sono presenti promozioni attive a cui puoi aderire
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapState } from "vuex";
import { VueAgile } from "../agile-slider";
import axios from "axios";
import { Carousel3d, Slide } from "vue-carousel-3d";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "active",
  components: {
    agile: VueAgile,
    Carousel3d,
    Slide,
    VueSlickCarousel,
  },
  data() {
    return {
      loadingState: "",
      vw: window.innerWidth,
      contests: "",
      key: "",
      piva: "",
      howBack: "white",
      length_: 0,
      view: false,
      cod_client: "",
      active: false,
      //left: '<svg x="0px" y="0px" viewBox="0 0 24 24"><path d="M16.2,21c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L9.6,12L17,4.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L6.8,12l8.8,8.7C15.7,20.9,16,21,16.2,21z"/></svg>',
      //right: '<svg x="0px" y="0px" viewBox="0 0 24 24"><path d="M7.8,21c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l7.4-7.3L7,4.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l8.8,8.7l-8.8,8.7C8.3,20.9,8,21,7.8,21z"/></svg>',
      left: require("../../assets/images/arrowLeft.png"),
      right: require("../../assets/images/arrowRight.png"),
    };
  },
  methods: {
    mouseOver: function (val) {
      this.active = "ACTIVE" + val;
    },
    mouseLeave: function (val) {
      this.active = false;
    },
    getContest: async function () {
      this.loadingState = true;
      var data = {
        piva: this.profile.piva,
        cod: this.profile.cod,
        group: this.profile.groupPh,
        status: "ACTIVE",
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        url: process.env.ROOT_API + "api/getContest",
        method: "POST",
        data: {
          data,
        },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          for (var i in resp.data) {
            var pass = JSON.parse(resp.data[i].config);
            resp.data[i].config = pass;
          }
          this.contests = resp.data;
          this.$track("getContest", "SUECCESS");
          this.$track("getContest", resp.data);
          if (resp.data) {
            this.length_ = resp.data.length;
            this.count = resp.data.length;

            if (this.count >= 2 && this.vw > 990) {
              this.length_ = 2;
            } else {
              this.length_ = 1;
            }
            if (this.count == 0) {
              this.view = false;
            } else {
              this.view = true;
            }
            this.loadingState = false;
          } else {
            this.loadingState = false;
          }
        })
        .catch((err) => {
          err.response.data = this.$decryptByAES(
            err.response.data,
            process.env.CRYPTKEY
          );
          this.$track("getContestActive", "ERROR");
        });
    },
    goToContest(index) {
      this.$track("goToContest", "promo " + this.contests[index].id);
      this.$track("goToContest", "piva " + this.piva);
      this.$track("goToContest", "codice farmacista " + this.cod_client);
      this.$router.push(
        "/contest/" +
          this.contests[index].id +
          "/" +
          this.piva +
          "/" +
          this.cod_client
      );
    },
    setProfileData: function () {
      this.piva = this.profile.piva;
      this.cod_client = this.profile.cod;
    },
  },

  watch: {
    getProfile: function (val) {
      this.setProfileData();
      this.getContest();
    },
  },
  mounted: function () {
    if (this.getProfile.piva) {
      this.setProfileData();
      this.getContest();
    }

    window.onresize = () => {
      this.vw = window.innerWidth;
    };
  },

  computed: {
    ...mapGetters([
      "getProfile",
      "isAuthenticated",
      "isProfileLoaded",
      "acceptCookies",
    ]),
    ...mapState({
      authLoading: (state) => state.auth.status === "loading",
      profile: (state) => state.user.profile,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/active.vue